var $ = jQuery.noConflict();


$(document).ready(function () {
    $('.filter_by_mob').click(function(e){
      e.preventDefault();
      $('body').addClass('filter_show');
      $(window).trigger('resize');
    });    
  $('.filter_close_icon').click(function(e){
      e.preventDefault();
      $('body').removeClass('filter_show');
  });

  $('.filter_close_popup').click(function(e){
      e.preventDefault();
      $('body').removeClass('filter_show');
  });

  $('.sort_by_mob').click(function(e){
      e.preventDefault();
      $('body').addClass('sortby_show');
      $(window).trigger('resize');
  });    
  $('.sortby_close_icon').click(function(e){
      e.preventDefault();
      $('body').removeClass('sortby_show');
  });
  

  $('.filerby_overlay').click(function(e){
    $('body').removeClass('filter_show');
  });

  $('.sortby_overlay').click(function(e){
    $('body').removeClass('sortby_show');
  });

  
  $('.sortby_mob_wrap .sortby_list li').on("click", function(){
    var sort_value = $(this).data('value');
    $(".short-list .form-control option[value='"+sort_value+"']").attr('selected', true).trigger('change');
  });
  setTimeout(function() {
    var select_shorting = $( ".custom_select option:selected" ).val();
    $(".sortby_list .custom-option[data-value='"+select_shorting+"']").addClass('active');
  }, 500); 

  
 

  var window_size = $(window).width();
  if (window_size <= 970) {
     if ($('.filter_sort_by_sec').is(":visible")) {
        $('.filter_title').trigger('click');
      } 
     if ($('.filter-sidebar .select-by-part .tag-list a').hasClass('active')){
        $('.select-by-part .filter_title').click();
      }
      
      if ($('.filter-sidebar .select-by-brand .tag-filters a').hasClass('tag_active')){
        $('.select-by-brand .filter_title').click();
      }
      if ($('.filter-sidebar .select-by-brand .tag-list').hasClass('active')){
        $('.select-by-brand .filter_title').click();
      }
      if ($('.filter-sidebar .select-by-model .tag-list').hasClass('active')){
         $('.select-by-model .filter_title').click();
      }
      if ($('.filter-sidebar .select-by-year .tag-filters__item').hasClass('active')){
        $('.select-by-year .filter_title').click();
      }

    
  }  

  // $('.select-by-brand a').click(function(e){
  //       e.preventDefault();
  //       var brand_link = $(this).attr("href");
  //   parts = brand_link.split("/"),
  //   last_part = parts[parts.length-1];
  //       alert(last_part);

  //     });
  // $('.brand_tag_active').click(function(){
  //   var ctag = $(this).data('id');
  // });
  // $('.model_tag_active').click(function(){
  //   var ctag = $(this).data('id');
  // });
  // $('.year_tag_active').click(function(){
  //   var year_ctag = $(this).data('id');
  //   $(".select-by-year li.tag-filters__item.active[data-id='"+year_ctag+"'] a")[0].click();
  // });

  
  
});
$(window).on('resize', function(){
    if ($('.filter_sort_by_sec').is(":visible")) {
      $('.filter_title').removeClass('up-arrow widget-collapse-show');
      $('.select-by-part .filter_title').removeClass('up-arrow');
      $('.sidebar-body').removeAttr('style');
      
    }
});

$(window).resize(function() {
  var window_size = $(window).width(); // New width
//alert(window_size);
});

$(window).on('load', function(){
    $('.upez--close-button').click(function(){    
      $('.modal-backdrop').remove();
    });
});